const RippleCnt = {
  symbol: "ٓXRP",
  name: "Ripple",
  meta: {
    title: "Buy Ripple | Sell Ripple | Ripple prices and charts",
    description:
      "Ripple is a well-known company for moving money on the Chinese blockchain, and XRP is the network's proprietary cryptocurrency. Buy and sell Ripple at the best price, lowest commission and fastest time in Quinnic Market.",
    keywords: "Ripple, buy Ripple, sell Ripple, Ripple price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: " چگونه ریپل بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید بایننس کوین کنید. قیمت ریپل در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول ریپل کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "برای ذخیره ریپل می‌توانید از انواع کیف‌پول‌های معتبر استفاده کنید. از بین کیف‌پول‌های سخت افزاری، لجر بهترین گزینه است. از بین کیف‌پول‌های نرم افزاری نیز می‌توانید از اتمیک وToast Wallet  برای نگهداری رمز ارز XRP استفاده کنید.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توان ریپل را نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در کوین‌نیک مارکت یک کیف پول اختصاصی و امن ریپل دارید، که می‌توانید رمز ارز ریپل خود را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا ریپل ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " اگر معتقدید که ریپل دارای پتانسیل بالایی است و احتمال دارد در دعوی SEC به نتیجه مطلوبی برسد، می‌توانید در XRP سرمایه گذاری کنید. به خاطر داشته باشید که ریپل حتی در مقایسه با سایر ارزهای رمزنگاری شده یک سرمایه گذاری پرخطر است",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Ripple",
      answer: "Buy_Ripple",
      id: "toggler1",
    },
    {
      question: "What is the best Ripple wallet?",
      answer: "Ripple_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Ripple at coinnik Market?",
      answer: "Keep_Ripple_description",
      id: "toggler3",
    },
    {
      question: "Is Ripple worth the investment?",
      answer: "Ripple_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Ripple",
        subTitle: "What is Ripple?",
        content: "What_Ripple",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Ripple",
        content: "Ripple_history_description",
        btnTitle: "Buy and sell Ripple",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Ripple without intermediaries in coinnik Market",
        subTitle: "Buy Ripple",
        content: "Buy_Ripple_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Ripple",
        content: "Sell_Ripple_description",
        btnTitle: "Buy and sell Ripple",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Ripple analysis on the blog",
  informationTitle: "Ripple market statistics and information",
};

export default RippleCnt;
